/** Year-over-year delta pill: null → gray "New"; up emerald ▲, down rose ▼. */
export function YoyPill({ pct }: { pct: number | null }) {
  if (pct === null) {
    return <span className="text-[11px] font-semibold px-1.5 py-0.5 rounded-full bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300">New</span>;
  }
  const up = pct >= 0;
  return (
    <span className={`text-[11px] font-semibold px-1.5 py-0.5 rounded-full ${up ? 'text-emerald-700 bg-emerald-100 dark:text-emerald-300 dark:bg-emerald-900/40' : 'text-rose-700 bg-rose-100 dark:text-rose-300 dark:bg-rose-900/40'}`}>
      {up ? '▲' : '▼'} {Math.abs(pct)}%
    </span>
  );
}
